'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_8f2c8bee = {"container":"MaskInput_module_container__5134a1ff"};
require("../../../assets/cjs/components/MaskInput/src/MaskInput~BTG5oZ4E.css");

exports.default = modules_8f2c8bee;
//# sourceMappingURL=MaskInput.module.less.js.map
